<template>
  <el-row
    class="card-objective"
    style="height: 432px;">
    <el-col
      :span="24"
      style="height: 144px;">
      <el-card
        class="card"
        shadow="hover">
        <p>Objectivo {{ title }}</p>
        <h1>{{ total }}</h1>
      </el-card>
    </el-col>
    <el-col
      :span="24"
      style="height: 144px;">
      <el-card
        class="card"
        shadow="hover">
        <p>{{ title }} por vender </p>
        <h1>{{ total - done }}</h1>
      </el-card>
    </el-col>
    <el-col
      :span="24"
      style="height: 141px;">
      <el-card
        class="card"
        shadow="hover">
        <p>{{ title }} Vendidos</p>
        <h1>{{ done }}</h1>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
/**
*
* CardObjective Component
*
* @author emartinez
* @copyright 2019, Marciano Studio S.C.
*/
export default {
  name: 'CardObjective',
  props: {
    total: {
      type: [Number, String],
      default: 0
    },
    done: {
      type: [Number, String],
      default: 0
    },
    title: {
      type: String,
      default: 'Tractores'
    }
  }
}
</script>

<style lang="scss" scoped>
.card-objective{
  height: 100%;
  background-color: #ffffff;
  .card{
    height: 100%;
    position: relative;
    border-radius: 0px;
    p{
      margin: 0;
      @include font-lato(14px, bold);
      color:#3E3E3E;
    }
    h1{
      margin: 0;
      @include font-primary(36px, light);
      color: #707070;
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/dashboard/card-objective.vue